const checkIfInValidNumber = (val: number | string) =>
  val === '' || val === null || val === undefined || Number.isNaN(Number(val));

export const isValidLat = (val: number | string) => {
  if (checkIfInValidNumber(val)) {
    return false;
  }
  return Number(val) >= -90 && Number(val) <= 90;
};

export const isValidLong = (val: number | string) => {
  if (checkIfInValidNumber(val)) {
    return false;
  }
  return Number(val) >= -180 && Number(val) <= 180;
};

/**
 * Parses RTK error to extract error code and message
 * @param error - RTK error object
 * @returns An object containing error code and message
 */
export function parseRTKError(error: any) {
  let errorCode: string | number | null = null;
  let errorMessage = 'Unknown error';
  if ('status' in error) {
    // FetchBaseQueryError
    errorCode = error.status;
    errorMessage =
      typeof error.data === 'string'
        ? error.data
        : (error.data as any)?.message || `HTTP ${error.status}`;
  } else if ('message' in error) {
    // SerializedError
    errorMessage = error.message || 'Serialized error';
    errorCode = error.code || null;
  }
  return { errorCode, errorMessage };
}
